import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Text, mergeStyleSets, Stack, ScreenWidthMinXLarge } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
import { routes } from '@shared/routerHistory';
import { NeutralColors } from '@fluentui/theme';
import { LinkedItem } from '@shared/components/linkedItem';
import classNames from 'classnames';
const titleAndTileStackStyle = {
    childrenGap: 16
};
const appDetailsLinkedItemsStyles = mergeStyleSets({
    container: {
        marginTop: 20
    },
    linkedItemsContainer: {
        marginTop: 15
    },
    header: {
        color: NeutralColors.gray130,
        fontWeight: 600
    },
    LinkedItemsStyle: {
        width: '456px',
        [`@media (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '312px'
        }
    }
});
const horizontalGapStackTokens = {
    childrenGap: 24
};
const getLinkedItemLink = ({ linkedItem, productId, context })=>{
    return context.buildHref(routes.appDetails, {
        productId,
        entityId: linkedItem.entityId
    }, {
        tab: 'Overview'
    });
};
const addinOnClick = ({ linkedItem, context, event })=>{
    const lastCtaType = linkedItem.ctaTypes[linkedItem.ctaTypes.length - 1];
    context.ctaCallback({
        entity: linkedItem,
        entityType: Constants.EntityType.App,
        ctaType: lastCtaType,
        actionModifier: Constants.Telemetry.ActionModifier.AppDetailCTAButton,
        hasLicense: false
    });
    event.preventDefault();
};
const renderLinkedItems = ({ billingCountryCode, context, productId, linkedItems, isSaaSRendering, isLoadingUserData, locale })=>{
    return /*#__PURE__*/ _jsx(Stack, {
        horizontal: true,
        wrap: true,
        tokens: horizontalGapStackTokens,
        children: linkedItems.map((item, index)=>/*#__PURE__*/ _jsx(Stack.Item, {
                className: classNames([
                    appDetailsLinkedItemsStyles.LinkedItemsStyle
                ]),
                children: /*#__PURE__*/ _jsx(LinkedItem, {
                    linkedItem: item,
                    billingCountryCode: billingCountryCode,
                    isInAppDetail: true,
                    isSaaSRendering: isSaaSRendering,
                    ctaButtonClick: isSaaSRendering ? ({ linkedItem })=>{
                        getLinkedItemLink({
                            linkedItem,
                            productId,
                            context
                        });
                    } : ({ linkedItem, event })=>{
                        addinOnClick({
                            linkedItem,
                            context,
                            event
                        });
                    },
                    isLoadingUserData: isLoadingUserData,
                    getLinkedItemLink: getLinkedItemLink,
                    locale: locale
                })
            }, index))
    });
};
export const AppDetailsLinkedItemsComponent = ({ billingCountryCode, productId, linkedItems, isSaaSRendering, isLoadingUserData, headerString, locale }, context)=>{
    return (linkedItems === null || linkedItems === void 0 ? void 0 : linkedItems.length) ? /*#__PURE__*/ _jsxs(Stack, {
        tokens: titleAndTileStackStyle,
        className: classNames([
            'linkedItemsContainer',
            [
                appDetailsLinkedItemsStyles.container
            ]
        ]),
        children: [
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: headerString && /*#__PURE__*/ _jsx(Text, {
                    variant: "mediumPlus",
                    className: appDetailsLinkedItemsStyles.header,
                    children: headerString
                })
            }),
            /*#__PURE__*/ _jsx(Stack.Item, {
                children: renderLinkedItems({
                    billingCountryCode,
                    productId,
                    linkedItems,
                    isSaaSRendering,
                    isLoadingUserData,
                    context,
                    locale
                })
            })
        ]
    }) : null;
};
AppDetailsLinkedItemsComponent.contextTypes = {
    buildHref: PropTypes.func,
    ctaCallback: PropTypes.func
};
export const AppDetailsLinkedItems = AppDetailsLinkedItemsComponent;
